document.querySelectorAll(".section .ingredients-glossary").forEach(glossary => {
    const input = glossary.querySelector(".custom-ing-search"); // search box
    const filter = glossary.querySelector("select[name=ing-filter]"); // dropdown filter
    const items = glossary.querySelectorAll(".ingredients__table [data-ingredient]");
    const closeBtn = glossary.querySelector(".close-x-btn");

    if (!input || !filter || !items.length) return;

    function applyFilter() {
        const searchValue = input.value.toLowerCase().trim();
        const filterValue = filter.value.toLowerCase().trim();
        console.log(searchValue, filterValue);

        // toggle close button for search
        closeBtn.style.display = searchValue ? "inline-block" : "none";

        items.forEach(item => {
            const ingredientName = item.querySelector("p[data-ingredient-title]")?.textContent.toLowerCase() || "";
            const foundIn = item.querySelector('[data-found-in]').getAttribute("data-found-in")?.toLowerCase() || "";

            const matchesSearch = !searchValue || ingredientName.includes(searchValue);
            const matchesFilter = filterValue === "all" || foundIn === "all-scents" || foundIn.includes(filterValue);
            console.log(item, matchesSearch, matchesFilter)

            if (matchesSearch && matchesFilter) {
                item.style.display = "";
            } else {
                item.style.display = "none";
            }
        });
    }

    // run when typing/pasting in search box
    input.addEventListener("input", applyFilter);

    // run when changing dropdown
    filter.addEventListener("change", applyFilter);

    // clear input on ❌ click
    closeBtn.addEventListener("click", function () {
        input.value = "";
        applyFilter();
    });
});

$(document).on('click', '.show-ingredients-popup', function(){
    document.body.classList.add('show-popup');
    $('.ingredients__popup').show();
});
$(document).on('click', '.ingredients__popup_close', function(){
    document.body.classList.remove('show-popup');
    $('.ingredients__popup').hide();
});
